// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__HO6rC","first":"Hero_first__u8hjW","second":"Hero_second__OU+oR"};